import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { GlobalContext } from 'components/context'

const Document = ({ membership, match }) => {
  const { t } = React.useContext(GlobalContext)

  if (!membership.documents || membership.documents.length === 0) {
    return null
  }

  const status = membership.documents.some(e => e.status === 'pending') ? 'unsigned' : 'signed'

  return (
    <div className={'documents'}>
      <h2>{ t('pages.membership.documents.title') }</h2>
      { t(`pages.membership.documents.${status}`) }
      <p>
        <Link to={`${match.path}/documents`}>
          { t('pages.membership.documents.link') }
        </Link>
      </p>
    </div>
  )
}

Document.propTypes = {
  match: PropTypes.object.isRequired,
  membership: PropTypes.object.isRequired,
}

export default Document
